import { Modal } from '@arco-design/web-vue';

import i18n from '@/i18n';

export function confirm(options) {
  if (typeof options === 'string') {
    options = {
      title: i18n.global.t('lang031'),
      content: options,
    };
  }

  return new Promise((resolve) => {
    Modal.confirm({
      simple: true,
      okText: i18n.global.t('lang244'),
      cancelText: i18n.global.t('lang301'),
      ...options,
      onOk: () => {
        options.onOk?.();
        resolve(true);
      },
      onCancel: () => {
        options.onCancel?.();
        resolve(false);
      },
    });

    document.activeElement?.blur();
  });
}
